import { InboxPreviewUsageRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/billing/inbox-preview-usage')({
  component: InboxPreviewUsageRoute,
});
